/**
 * Component adapted from SEAC Corporate Website
 * https://github.com/oozou/seac-corporate-website/blob/v1.0.3/packages/web/src/ui-kit/Markdown.tsx
 */

import ReactMarkdown from 'react-markdown';
import sanitize from 'rehype-sanitize';
import gfm from 'remark-gfm';
import { FC } from 'react';
import cx from 'classnames';

interface IMarkdown {
  children: string;
  className?: string;
  components?: Record<string, any>;
}

const NumberedList = ({ children }) => (
  <ol className="ml-6 list-outside list-decimal">{children}</ol>
);

const UnorderedList = ({ children }) => (
  <ul className="ml-6 list-outside list-disc">{children}</ul>
);

const A = (props) => (
  <a className="underline hover:text-brand-primary" href={props.href}>
    {props.children}
  </a>
);

const Strong = (props) => <span className="font-bold">{props.children}</span>;

const P = (props) => (
  //  Workaround for multiples <p> in div with line-clamp not working with Safari
  <span className="text-body font-regular">{props.children}</span>
);

const Li = ({ children }) => <li>{children}</li>;

const Markdown: FC<IMarkdown> = ({
  children,
  components = {},
  className,
  ...props
}) => {
  return (
    <ReactMarkdown
      className={cx(
        'flex flex-col space-y-[28px] overflow-hidden whitespace-pre-wrap',
        className,
      )}
      remarkPlugins={[gfm]}
      rehypePlugins={[sanitize]}
      components={{
        ...{
          ol: NumberedList,
          ul: UnorderedList,
          a: A,
          strong: Strong,
          p: P,
          li: Li,
        },
        ...components,
      }}
      {...props}
    >
      {children}
    </ReactMarkdown>
  );
};

export default Markdown;
